import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['element'];

	toggleContent() {
		if (this.elementTarget.hasAttribute('data-group-toggled')) {
			this.elementTarget.removeAttribute('data-group-toggled');
		} else {
			this.elementTarget.setAttribute('data-group-toggled', true);
		}
	}
}
